<script setup lang="ts">
defineProps<{
  id: string;
  title: string;
  shaded?: boolean;
}>();
</script>

<template>
  <section
    :id="id"
    :aria-labelledby="`${id}-heading`"
    tabindex="-1"
    :class="[
      'scroll-mt-28 border-t border-slate-200 px-4 py-10 focus:outline-2 focus:outline-brand-700 sm:px-6 sm:py-12 lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)] lg:gap-10 lg:px-8',
      shaded ? 'bg-brand-50' : 'bg-white',
    ]"
  >
    <h3
      :id="`${id}-heading`"
      class="max-w-sm font-heading text-xl font-semibold leading-snug text-brand-900 sm:text-2xl"
    >
      {{ title }}
    </h3>
    <div class="mt-5 min-w-0 lg:mt-0">
      <div class="max-w-2xl leading-relaxed text-slate-800">
        <slot />
      </div>
      <div class="mt-6 border-t border-slate-300 pt-5">
        <p class="text-sm font-semibold text-brand-900">
          Questions to explore
        </p>
        <slot name="questions" />
      </div>
    </div>
  </section>
</template>